const CLPSeparator = () => {
  return (
    <div className="border-b-[1px] border-b-[#cccccc]" />
  );
};

export default CLPSeparator;
